export default [
  {
    id: '2026-07-hackathon',
    title: 'July 2026',
    contributors: [
      {
        user_id: 39012371,
        username: 'vivekyarra567',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 70,
        merged_merge_requests: 44,
        merged_with_issues: 44,
        merged_commits: 44,
        added_notes: 42,
        opened_issues: 34,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 5720,
        plan_points: 212,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 5932,
      },
      {
        user_id: 40377794,
        username: 'RedZapdos123',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 44,
        merged_merge_requests: 33,
        merged_with_issues: 8,
        merged_commits: 33,
        added_notes: 19,
        opened_issues: 3,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 3540,
        plan_points: 34,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 3574,
      },
      {
        user_id: 30761928,
        username: 'pishel65',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 31,
        merged_merge_requests: 27,
        merged_with_issues: 1,
        merged_commits: 27,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 2730,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 2735,
      },
      {
        user_id: 40528436,
        username: 'ihopenre-eng',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 32,
        merged_merge_requests: 19,
        merged_with_issues: 19,
        merged_commits: 16,
        added_notes: 10,
        opened_issues: 30,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 2410,
        plan_points: 160,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 2570,
      },
      {
        user_id: 30208072,
        username: 'ray.tien0907',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 21,
        merged_merge_requests: 10,
        merged_with_issues: 10,
        merged_commits: 10,
        added_notes: 15,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1300,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1315,
      },
      {
        user_id: 39194174,
        username: 'anbuchelvanganesan.cse2024',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 9,
        merged_merge_requests: 9,
        merged_with_issues: 9,
        merged_commits: 9,
        added_notes: 26,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1170,
        plan_points: 36,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 1207,
      },
      {
        user_id: 26611891,
        username: 'titikshabansal0209',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 8,
        merged_merge_requests: 4,
        merged_with_issues: 3,
        merged_commits: 4,
        added_notes: 60,
        opened_issues: 1,
        added_labels: 18,
        closed_issues: 0,
        added_events: 1,
        added_contents: 0,
        discord_messages: 5,
        discord_replies: 7,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 490,
        plan_points: 83,
        engage_points: 500,
        discuss_points: 19,
        translate_points: 0,
        bonus_points: 0,
        score: 1092,
      },
      {
        user_id: 31535429,
        username: 'momosolom',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 10,
        merged_merge_requests: 8,
        merged_with_issues: 8,
        merged_commits: 8,
        added_notes: 13,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1040,
        plan_points: 13,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1053,
      },
      {
        user_id: 31534691,
        username: 'Mawadda0',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 10,
        merged_merge_requests: 6,
        merged_with_issues: 6,
        merged_commits: 6,
        added_notes: 21,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 780,
        plan_points: 21,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 801,
      },
      {
        user_id: 9500609,
        username: 'tnt4brain',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 12,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        merged_commits: 5,
        added_notes: 54,
        opened_issues: 2,
        added_labels: 2,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 650,
        plan_points: 66,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 716,
      },
      {
        user_id: 241647,
        username: 'rantoniuk',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 8,
        merged_merge_requests: 5,
        merged_with_issues: 4,
        merged_commits: 5,
        added_notes: 27,
        opened_issues: 2,
        added_labels: 5,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 4,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 620,
        plan_points: 42,
        engage_points: 0,
        discuss_points: 9,
        translate_points: 0,
        bonus_points: 0,
        score: 671,
      },
      {
        user_id: 35638078,
        username: '4shm1td06',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 17,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        merged_commits: 4,
        added_notes: 39,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 520,
        plan_points: 44,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 564,
      },
      {
        user_id: 34603105,
        username: 'lucianoscarpaci',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 6,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        merged_commits: 4,
        added_notes: 19,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 520,
        plan_points: 19,
        engage_points: 0,
        discuss_points: 2,
        translate_points: 0,
        bonus_points: 0,
        score: 541,
      },
      {
        user_id: 35383631,
        username: 'iamRabia_N',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 5,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 398,
      },
      {
        user_id: 5958906,
        username: 'gkepas',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 1,
        merged_commits: 3,
        added_notes: 11,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 330,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 341,
      },
      {
        user_id: 32330646,
        username: 'PandaBean18',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 7,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 15,
        translate_points: 0,
        bonus_points: 0,
        score: 282,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 5,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 10,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 275,
      },
      {
        user_id: 40453360,
        username: 'RehanChalana',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 11,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 272,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 5,
        core_team: true,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 66,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 71,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 271,
      },
      {
        user_id: 32517994,
        username: 'ahmed-abdelrady-SE',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 266,
      },
      {
        user_id: 40388046,
        username: 'orbit-automation-bot',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 240,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 240,
      },
      {
        user_id: 11168034,
        username: 'HARESH-D',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 230,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 233,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 230,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 233,
      },
      {
        user_id: 26348059,
        username: 'jspagnola',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 207,
      },
      {
        user_id: 5332,
        username: 'bbodenmiller',
        contributor_level: 5,
        core_team: true,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 203,
      },
      {
        user_id: 35496782,
        username: 'koves',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 13,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 3,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 33,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 7,
        translate_points: 33,
        bonus_points: 0,
        score: 177,
      },
      {
        user_id: 33199961,
        username: 'Yugesh-Kumar',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 160,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 160,
      },
      {
        user_id: 3757837,
        username: 'fongse',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 3,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 154,
      },
      {
        user_id: 25983954,
        username: 'BoxBoxJason',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 16,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 146,
      },
      {
        user_id: 15539399,
        username: 'DhairyaMajmudar',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 13,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 13,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 143,
      },
      {
        user_id: 31983917,
        username: 'salamkar',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 137,
      },
      {
        user_id: 2687207,
        username: 'skkzsh',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 137,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 137,
      },
      {
        user_id: 40423997,
        username: 'apuravagrawal07',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 42,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 136,
      },
      {
        user_id: 37072096,
        username: 'Vinayreddy765',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 133,
      },
      {
        user_id: 7882302,
        username: 'guillaume.chauvel',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 133,
      },
      {
        user_id: 25866107,
        username: 'kunal261708',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 133,
      },
      {
        user_id: 40415569,
        username: 'thunetran',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 31466356,
        username: 'OMar-Adelll',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 131,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 131,
      },
      {
        user_id: 537634,
        username: 'tukusejssirs',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 21230898,
        username: 'syedsaifalialvi',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 24581512,
        username: 'cesarihinojosa',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 25292121,
        username: 'Mazen-Ghanaym',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 30028690,
        username: 'Ahmad-Faraj',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 851296,
        username: 'behrmann',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 4,
        core_team: true,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 2,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 13,
        engage_points: 0,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 127,
      },
      {
        user_id: 31784485,
        username: 'dankparth',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 9,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 19,
        translate_points: 0,
        bonus_points: 0,
        score: 126,
      },
      {
        user_id: 14712395,
        username: 'dishatalreja1202',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 112,
      },
      {
        user_id: 30524624,
        username: 'sravanelli',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 109,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 109,
      },
      {
        user_id: 26714177,
        username: 'xingli.wu',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 106,
      },
      {
        user_id: 2235372,
        username: 'pmhahn',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 106,
      },
      {
        user_id: 6033141,
        username: 'vennemp',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 104,
      },
      {
        user_id: 8841583,
        username: 'mness',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 103,
      },
      {
        user_id: 30603084,
        username: 'MatthewOscar',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 102,
      },
      {
        user_id: 1245908,
        username: 'jtrost',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 5,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 10222111,
        username: 'mattpensworth',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 6156568,
        username: 'kang8',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 84,
      },
      {
        user_id: 30804365,
        username: 'emallinger',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29321593,
        username: 'eur-ocalvo',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11636842,
        username: 'mkuurstra',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3399361,
        username: 'adirelle',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3095957,
        username: 'ohayak',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 16,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3964391,
        username: 'heiko.thiel',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 307076,
        username: 'fxs',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 14,
        opened_issues: 3,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 29,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 33363466,
        username: 'eugene-harold-krabs',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 130,
        opened_issues: 3,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 145,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 39486403,
        username: 'Saurav-Gupta-9741',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 154690,
        username: 'sauerburger',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 36895333,
        username: 'pabloosabaterr',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 751731,
        username: 'karakTaka',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 39201175,
        username: 'anuragdashore1024',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 16,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 16,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 4828426,
        username: 'r.baradari',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 16,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 21,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1414740,
        username: 'martizih',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 6,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 42,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 52,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 40460386,
        username: 'kartik-m39',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 13093824,
        username: 'clement.bois',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 19,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 19,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2683007,
        username: 'jeromezng-gitlab',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 34950459,
        username: 'andrea.prieguerodriguez',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14857804,
        username: 'nraj0408',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 38301653,
        username: 'csning1998',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 7825963,
        username: 'thisisrick25',
        contributor_level: 3,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 2,
        discord_replies: 7,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 16,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2223282,
        username: 'michael-herwig',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29321868,
        username: 'karaolidis',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 39837596,
        username: '1.nn',
        contributor_level: 0,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 637784,
        username: 'andrewdunndev',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1763497,
        username: 'roma-bb8',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 34744750,
        username: 'sentry_insights_bot',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2958599,
        username: 'mklarmann',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29585132,
        username: 'zhanghaiwei55',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 37490098,
        username: 'ash-abdellatif',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14375494,
        username: 'jdve',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 5887228,
        username: 'mptr',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 34909640,
        username: 'zidanesalim',
        contributor_level: 2,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25180212,
        username: 'devminds-bot',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 32582445,
        username: 'dependabot',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 9038548,
        username: 'zerowhy',
        contributor_level: 1,
        core_team: false,
        team_member: false,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        core_team: false,
        team_member: false,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2026-04-hackathon',
    title: 'April 2026',
    contributors: [
      {
        user_id: 30578807,
        username: 'hhubert14',
        contributor_level: 4,
        opened_merge_requests: 184,
        merged_merge_requests: 149,
        merged_with_issues: 32,
        merged_commits: 149,
        added_notes: 50,
        opened_issues: 3,
        added_labels: 2,
        closed_issues: 2,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 31620,
        plan_points: 77,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 31697,
      },
      {
        user_id: 30304947,
        username: 'bobsingh.dev',
        contributor_level: 4,
        opened_merge_requests: 109,
        merged_merge_requests: 98,
        merged_with_issues: 0,
        merged_commits: 9,
        added_notes: 34,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 13880,
        plan_points: 34,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 13914,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 5,
        opened_merge_requests: 13,
        merged_merge_requests: 13,
        merged_with_issues: 7,
        merged_commits: 13,
        added_notes: 19,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 3020,
        plan_points: 19,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 3039,
      },
      {
        user_id: 33048684,
        username: 'priyansh3133',
        contributor_level: 3,
        opened_merge_requests: 15,
        merged_merge_requests: 13,
        merged_with_issues: 7,
        merged_commits: 13,
        added_notes: 20,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 4,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 2270,
        plan_points: 25,
        engage_points: 0,
        discuss_points: 8,
        translate_points: 0,
        bonus_points: 0,
        score: 2303,
      },
      {
        user_id: 32995401,
        username: 'nexpectArpit',
        contributor_level: 3,
        opened_merge_requests: 56,
        merged_merge_requests: 16,
        merged_with_issues: 6,
        merged_commits: 16,
        added_notes: 20,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1600,
        plan_points: 20,
        engage_points: 0,
        discuss_points: 2,
        translate_points: 0,
        bonus_points: 0,
        score: 1622,
      },
      {
        user_id: 30761928,
        username: 'pishel65',
        contributor_level: 3,
        opened_merge_requests: 11,
        merged_merge_requests: 8,
        merged_with_issues: 6,
        merged_commits: 7,
        added_notes: 119,
        opened_issues: 7,
        added_labels: 7,
        closed_issues: 7,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1290,
        plan_points: 196,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1486,
      },
      {
        user_id: 30603084,
        username: 'MatthewOscar',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 2,
        merged_commits: 5,
        added_notes: 24,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 2,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 1,
        code_points: 1120,
        plan_points: 34,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 200,
        score: 1354,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 5,
        opened_merge_requests: 11,
        merged_merge_requests: 11,
        merged_with_issues: 3,
        merged_commits: 11,
        added_notes: 21,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1190,
        plan_points: 21,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1211,
      },
      {
        user_id: 108137,
        username: 'mikelolasagasti',
        contributor_level: 2,
        opened_merge_requests: 8,
        merged_merge_requests: 6,
        merged_with_issues: 5,
        merged_commits: 6,
        added_notes: 11,
        opened_issues: 8,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 850,
        plan_points: 51,
        engage_points: 0,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 0,
        score: 904,
      },
      {
        user_id: 5958906,
        username: 'gkepas',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 3,
        merged_with_issues: 2,
        merged_commits: 3,
        added_notes: 10,
        opened_issues: 0,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 2,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 720,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 735,
      },
      {
        user_id: 34909640,
        username: 'zidanesalim',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 21,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 520,
        plan_points: 27,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 547,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 520,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 524,
      },
      {
        user_id: 32973123,
        username: 'coderboy17',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 480,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 490,
      },
      {
        user_id: 37386452,
        username: 'gatlavishweshwarreddy26',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 460,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 467,
      },
      {
        user_id: 1147472,
        username: 'amulvany',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 460,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 466,
      },
      {
        user_id: 26195738,
        username: 'catarina_ferreira',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 13,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 330,
        plan_points: 18,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 348,
      },
      {
        user_id: 29088934,
        username: 'webmekanic',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 13,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 330,
        plan_points: 13,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 343,
      },
      {
        user_id: 33017979,
        username: 'Emmanuel326',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 1,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 9,
        engage_points: 200,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 339,
      },
      {
        user_id: 35321894,
        username: 'UltChowsk',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 3,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 330,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 335,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 5,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 21,
        opened_issues: 10,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 71,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 271,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 265,
      },
      {
        user_id: 17749792,
        username: 'ivane_gkomarteli',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 265,
      },
      {
        user_id: 37085709,
        username: 'calebmadara58',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 263,
      },
      {
        user_id: 35283511,
        username: 'olegykzde',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 263,
      },
      {
        user_id: 22227988,
        username: 'GarvitSinghal47',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 262,
      },
      {
        user_id: 20730986,
        username: 'hichemdahi57',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 261,
      },
      {
        user_id: 34800714,
        username: 'NguyenEvan',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 261,
      },
      {
        user_id: 35207831,
        username: 'mohammedhossam86',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 260,
      },
      {
        user_id: 34603105,
        username: 'lucianoscarpaci',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 31,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 3,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 31,
        engage_points: 0,
        discuss_points: 7,
        translate_points: 0,
        bonus_points: 0,
        score: 238,
      },
      {
        user_id: 32644122,
        username: 'ShawkyXr',
        contributor_level: 3,
        opened_merge_requests: 20,
        merged_merge_requests: 16,
        merged_with_issues: 10,
        merged_commits: 16,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 10,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 220,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 10,
        bonus_points: 0,
        score: 238,
      },
      {
        user_id: 33199961,
        username: 'Yugesh-Kumar',
        contributor_level: 3,
        opened_merge_requests: 44,
        merged_merge_requests: 23,
        merged_with_issues: 4,
        merged_commits: 4,
        added_notes: 17,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 220,
        plan_points: 17,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 237,
      },
      {
        user_id: 13135099,
        username: 'CBID2',
        contributor_level: 3,
        opened_merge_requests: 6,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 3,
        discord_replies: 6,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 210,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 15,
        translate_points: 0,
        bonus_points: 0,
        score: 230,
      },
      {
        user_id: 30375223,
        username: 'therealrinku',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 20,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 20,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 15,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 2,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 84,
        engage_points: 0,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 218,
      },
      {
        user_id: 20488057,
        username: 'ealexandrohin',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 207,
      },
      {
        user_id: 14154601,
        username: 'n7800',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 206,
      },
      {
        user_id: 34783722,
        username: 'Meirzhan05',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 206,
      },
      {
        user_id: 34797136,
        username: 'manrajs1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 201,
      },
      {
        user_id: 23402942,
        username: 'sarahhchapman',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 201,
      },
      {
        user_id: 30614634,
        username: 'ep3100',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 200,
      },
      {
        user_id: 23322786,
        username: 'prabhakarrai',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 160,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 163,
      },
      {
        user_id: 19666194,
        username: 'maxthier',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 10,
        opened_issues: 4,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 30,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 160,
      },
      {
        user_id: 2235372,
        username: 'pmhahn',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 20,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 1,
        forum_replies: 1,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 25,
        engage_points: 0,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 0,
        score: 158,
      },
      {
        user_id: 35228325,
        username: 'priyusha-ch99',
        contributor_level: 1,
        opened_merge_requests: 5,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 27,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 27,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 157,
      },
      {
        user_id: 33133927,
        username: 'Ambo311',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 1,
        added_labels: 16,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 154,
      },
      {
        user_id: 28523857,
        username: 'boweflex',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 14,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 19,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 149,
      },
      {
        user_id: 12907855,
        username: 'anupborker',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 10,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 140,
      },
      {
        user_id: 21445567,
        username: '4censord',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 5,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 140,
      },
      {
        user_id: 1388736,
        username: 'deveshchatuphale7',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 134,
      },
      {
        user_id: 37072096,
        username: 'Vinayreddy765',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 133,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 131,
      },
      {
        user_id: 28479455,
        username: 'elstoncrasta3003',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 131,
      },
      {
        user_id: 9088155,
        username: 'gjramayya1',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 22,
        opened_issues: 0,
        added_labels: 7,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 29,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 129,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 5,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 23,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 23,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 123,
      },
      {
        user_id: 34710603,
        username: 'andreanun',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 111,
      },
      {
        user_id: 5350514,
        username: 'aecoleman',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 2,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 105,
      },
      {
        user_id: 10222111,
        username: 'mattpensworth',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 103,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 25292121,
        username: 'Mazen-Ghanaym',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 36601106,
        username: 'igzab',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 83,
      },
      {
        user_id: 3706495,
        username: 'hugoncosta',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 82,
      },
      {
        user_id: 776981,
        username: 'm.baur',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 82,
      },
      {
        user_id: 34785518,
        username: 'Moo4president',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 36184920,
        username: 'alipabdullah779',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 5757639,
        username: 'ahmednfwela',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29021107,
        username: 'Nsanjayboruds',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21810588,
        username: 'Profidev',
        contributor_level: 0,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1829657,
        username: 'metabytewien',
        contributor_level: 1,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11636842,
        username: 'mkuurstra',
        contributor_level: 4,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23075558,
        username: 'poojabhavani19',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30028690,
        username: 'Ahmad-Faraj',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19423278,
        username: 'marc.b.orange',
        contributor_level: 2,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 18925,
        username: 'ryodine',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30727778,
        username: 'mohkarem7',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3526849,
        username: 'eazybright',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 7882302,
        username: 'guillaume.chauvel',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 9080899,
        username: 'Deltamir',
        contributor_level: 3,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3399361,
        username: 'adirelle',
        contributor_level: 2,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 35496782,
        username: 'koves',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 4,
        discord_replies: 2,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 8,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 20061735,
        username: 'anthops',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 14,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3664375,
        username: 'chanmickyyun',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 13093824,
        username: 'clement.bois',
        contributor_level: 3,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 4755982,
        username: 'jon_naimuri',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 8428791,
        username: 'u.kilianpaquier',
        contributor_level: 2,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2601285,
        username: 'andrcuns',
        contributor_level: 2,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 10522535,
        username: 'ah_v',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25078359,
        username: 'aamirpatel711-admin',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1728328,
        username: 'averrie',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23310382,
        username: 'btwshivam',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29841609,
        username: 'Dev-phantom',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 2,
        discord_replies: 16,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 34,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 9460441,
        username: 'Aymen_hermi',
        contributor_level: 1,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30722311,
        username: 'vijeta004',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 8795873,
        username: 'tanstaafl',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 11,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29580426,
        username: 'official.harshith1',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 5178553,
        username: 'joukewitteveen',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 44745,
        username: 'xrow',
        contributor_level: 3,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1098309,
        username: 'osechet',
        contributor_level: 1,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 6265352,
        username: 'edith007',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 5396833,
        username: 'YoanSimco',
        contributor_level: 4,
        opened_merge_requests: 0,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 37494083,
        username: 'misterhazemsaid-maker',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2026-01-hackathon',
    title: 'January 2026',
    contributors: [
      {
        user_id: 28757681,
        username: 'Jay2006sawant',
        contributor_level: 3,
        opened_merge_requests: 59,
        merged_merge_requests: 45,
        merged_with_issues: 45,
        merged_commits: 1,
        added_notes: 104,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 4970,
        plan_points: 104,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 5074,
      },
      {
        user_id: 29088934,
        username: 'webmekanic',
        contributor_level: 4,
        opened_merge_requests: 43,
        merged_merge_requests: 41,
        merged_with_issues: 14,
        merged_commits: 41,
        added_notes: 20,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 1,
        discord_messages: 2,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 4520,
        plan_points: 26,
        engage_points: 200,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 4750,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 36,
        merged_merge_requests: 30,
        merged_with_issues: 29,
        merged_commits: 30,
        added_notes: 20,
        opened_issues: 4,
        added_labels: 4,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 86,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 3870,
        plan_points: 44,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 86,
        bonus_points: 0,
        score: 4000,
      },
      {
        user_id: 25292121,
        username: 'Mazen-Ghanaym',
        contributor_level: 3,
        opened_merge_requests: 94,
        merged_merge_requests: 21,
        merged_with_issues: 21,
        merged_commits: 21,
        added_notes: 120,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 17,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 4,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 2730,
        plan_points: 205,
        engage_points: 0,
        discuss_points: 8,
        translate_points: 0,
        bonus_points: 0,
        score: 2943,
      },
      {
        user_id: 21230898,
        username: 'syedsaifalialvi',
        contributor_level: 3,
        opened_merge_requests: 24,
        merged_merge_requests: 19,
        merged_with_issues: 18,
        merged_commits: 19,
        added_notes: 37,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 2440,
        plan_points: 37,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 2477,
      },
      {
        user_id: 13134593,
        username: 'MacArthur955',
        contributor_level: 3,
        opened_merge_requests: 22,
        merged_merge_requests: 22,
        merged_with_issues: 0,
        merged_commits: 5,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1860,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1860,
      },
      {
        user_id: 25930789,
        username: 'yugannkt',
        contributor_level: 2,
        opened_merge_requests: 18,
        merged_merge_requests: 13,
        merged_with_issues: 12,
        merged_commits: 13,
        added_notes: 10,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 1660,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1670,
      },
      {
        user_id: 32714213,
        username: 'Coderxrohan',
        contributor_level: 2,
        opened_merge_requests: 7,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        merged_commits: 5,
        added_notes: 32,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 1,
        added_contents: 1,
        discord_messages: 2,
        discord_replies: 5,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 20,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 650,
        plan_points: 37,
        engage_points: 700,
        discuss_points: 12,
        translate_points: 20,
        bonus_points: 0,
        score: 1419,
      },
      {
        user_id: 30770856,
        username: 'HamzaHassanain',
        contributor_level: 2,
        opened_merge_requests: 10,
        merged_merge_requests: 8,
        merged_with_issues: 6,
        merged_commits: 8,
        added_notes: 34,
        opened_issues: 5,
        added_labels: 5,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 980,
        plan_points: 64,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1044,
      },
      {
        user_id: 32455758,
        username: 'otutukingsley',
        contributor_level: 2,
        opened_merge_requests: 8,
        merged_merge_requests: 6,
        merged_with_issues: 3,
        merged_commits: 6,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 690,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 699,
      },
      {
        user_id: 6409054,
        username: 'yashmaheshwari',
        contributor_level: 3,
        opened_merge_requests: 108,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        merged_commits: 5,
        added_notes: 48,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 650,
        plan_points: 48,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 698,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 5,
        opened_merge_requests: 6,
        merged_merge_requests: 6,
        merged_with_issues: 1,
        merged_commits: 6,
        added_notes: 48,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 630,
        plan_points: 53,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 683,
      },
      {
        user_id: 33146000,
        username: 'tanmaykhot',
        contributor_level: 2,
        opened_merge_requests: 8,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        merged_commits: 5,
        added_notes: 13,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 4,
        discord_replies: 4,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 650,
        plan_points: 13,
        engage_points: 0,
        discuss_points: 12,
        translate_points: 0,
        bonus_points: 0,
        score: 675,
      },
      {
        user_id: 33162153,
        username: 'rv2205',
        contributor_level: 2,
        opened_merge_requests: 7,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        merged_commits: 5,
        added_notes: 19,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 650,
        plan_points: 19,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 670,
      },
      {
        user_id: 5396833,
        username: 'YoanSimco',
        contributor_level: 3,
        opened_merge_requests: 6,
        merged_merge_requests: 6,
        merged_with_issues: 0,
        merged_commits: 6,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 600,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 604,
      },
      {
        user_id: 852944,
        username: 'alexandear',
        contributor_level: 3,
        opened_merge_requests: 6,
        merged_merge_requests: 5,
        merged_with_issues: 1,
        merged_commits: 5,
        added_notes: 9,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 530,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 545,
      },
      {
        user_id: 33045418,
        username: 'mohamedmongy96',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        merged_commits: 4,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 520,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 524,
      },
      {
        user_id: 33199961,
        username: 'Yugesh-Kumar',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 4,
        merged_with_issues: 3,
        merged_commits: 2,
        added_notes: 10,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 450,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 460,
      },
      {
        user_id: 32892386,
        username: 'preethiatchudan',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 14,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 414,
      },
      {
        user_id: 32131412,
        username: 'Priyans00',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 20,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 20,
        engage_points: 0,
        discuss_points: 2,
        translate_points: 0,
        bonus_points: 0,
        score: 412,
      },
      {
        user_id: 12949888,
        username: 'AmrRiyad',
        contributor_level: 2,
        opened_merge_requests: 9,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 14,
        opened_issues: 0,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 405,
      },
      {
        user_id: 13277347,
        username: 'bhagabanghadai043',
        contributor_level: 1,
        opened_merge_requests: 5,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 400,
      },
      {
        user_id: 25238487,
        username: 'SharkyBytes',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 390,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 395,
      },
      {
        user_id: 7825963,
        username: 'thisisrick25',
        contributor_level: 3,
        opened_merge_requests: 24,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 27,
        opened_issues: 0,
        added_labels: 14,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 7,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 41,
        engage_points: 0,
        discuss_points: 15,
        translate_points: 0,
        bonus_points: 0,
        score: 316,
      },
      {
        user_id: 12245858,
        username: 'Ruislip',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        merged_commits: 3,
        added_notes: 10,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 300,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 310,
      },
      {
        user_id: 9080899,
        username: 'Deltamir',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        merged_commits: 3,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 300,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 300,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 5,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 30,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 40,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 300,
      },
      {
        user_id: 31784485,
        username: 'dankparth',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 24,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 284,
      },
      {
        user_id: 33170698,
        username: 'osu_Vanilla',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 14,
        opened_issues: 2,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 284,
      },
      {
        user_id: 30375223,
        username: 'therealrinku',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 21,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 21,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 281,
      },
      {
        user_id: 9535650,
        username: 'aishahsofea',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 18,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 18,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 278,
      },
      {
        user_id: 32526900,
        username: 'Niko-Geo',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 268,
      },
      {
        user_id: 31479191,
        username: 'lins.m.amanda',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 268,
      },
      {
        user_id: 5958906,
        username: 'gkepas',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 267,
      },
      {
        user_id: 22881837,
        username: 'mb8504',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 265,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 260,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 261,
      },
      {
        user_id: 567667,
        username: 'prakashdivyy',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        added_notes: 14,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 230,
        plan_points: 14,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 244,
      },
      {
        user_id: 26635213,
        username: 'hendrikbreuer',
        contributor_level: 0,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 205,
      },
      {
        user_id: 14380609,
        username: 'yogeshdave',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 200,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 202,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 5,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 97,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 97,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 197,
      },
      {
        user_id: 5850837,
        username: 'lcdlyxrqy',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 180,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 180,
      },
      {
        user_id: 152826,
        username: 'ben.boeckel',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 160,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 166,
      },
      {
        user_id: 29163783,
        username: 'bhagathemang360',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 11,
        opened_issues: 3,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 26,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 156,
      },
      {
        user_id: 28614569,
        username: 'Aayush-Saini',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 24,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 24,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 154,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 10,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 3,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 15,
        engage_points: 0,
        discuss_points: 6,
        translate_points: 0,
        bonus_points: 0,
        score: 151,
      },
      {
        user_id: 33039843,
        username: 'seif-hatem',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 139,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 139,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 9,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 139,
      },
      {
        user_id: 33196263,
        username: 'ashi2004',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 137,
      },
      {
        user_id: 1276763,
        username: 'JMLX',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 136,
      },
      {
        user_id: 4343069,
        username: 'rc-chuah',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 136,
      },
      {
        user_id: 18595316,
        username: 'alanrichman',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 135,
      },
      {
        user_id: 25229781,
        username: 'n.h.long.9697',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 135,
      },
      {
        user_id: 8428791,
        username: 'u.kilianpaquier',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 15,
        opened_issues: 4,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 35,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 135,
      },
      {
        user_id: 14276665,
        username: 'WoodyWillis',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 133,
      },
      {
        user_id: 10082086,
        username: 'telliffoshea',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 26287925,
        username: 'mohamed.othman27',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 33182036,
        username: 'noureldeanhaggag',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 132,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 131,
      },
      {
        user_id: 30709974,
        username: 'yashes7516',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 30761928,
        username: 'pishel65',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 23080818,
        username: 'Vignesh025',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 130,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 130,
      },
      {
        user_id: 28219759,
        username: 'rishisulakhe',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 17,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 17,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 127,
      },
      {
        user_id: 5219924,
        username: 'Taucher2003',
        contributor_level: 5,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 8,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 16,
        translate_points: 0,
        bonus_points: 0,
        score: 120,
      },
      {
        user_id: 31690317,
        username: 'nopejs',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 117,
      },
      {
        user_id: 27459501,
        username: 'Melo-6',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 2,
        discord_replies: 4,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 10,
        translate_points: 0,
        bonus_points: 0,
        score: 113,
      },
      {
        user_id: 30028690,
        username: 'Ahmad-Faraj',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 110,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 111,
      },
      {
        user_id: 2850414,
        username: 'monsterbitar',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 5,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 10,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
      },
      {
        user_id: 14375494,
        username: 'jdve',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 108,
      },
      {
        user_id: 822815,
        username: 'SinaMoghaddas',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 7,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 7,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 107,
      },
      {
        user_id: 22939611,
        username: 'jishnuteegala',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 106,
      },
      {
        user_id: 1147472,
        username: 'amulvany',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 104,
      },
      {
        user_id: 564782,
        username: 'beber80',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 103,
      },
      {
        user_id: 33077708,
        username: 'jordy.barre.ext',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 102,
      },
      {
        user_id: 2835149,
        username: 'pismy',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 102,
      },
      {
        user_id: 73292,
        username: 'rmoreas',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 102,
      },
      {
        user_id: 2002210,
        username: 'schliesser',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 102,
      },
      {
        user_id: 8640819,
        username: 'stenuta',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 6615211,
        username: 'somtom',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 1267399,
        username: 'filmor',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 31672821,
        username: 'kgadgil1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 2105385,
        username: 'girijasa',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 101,
      },
      {
        user_id: 10058918,
        username: 'blackstream-x',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 22220146,
        username: 'zhygis',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 26489478,
        username: 'j.m.doherty',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 26075236,
        username: 'benplus',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 25338447,
        username: 'SvenPistre',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 25015328,
        username: 'jose_felix',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 100,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 100,
      },
      {
        user_id: 14380650,
        username: 'vishalchouhan',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 82,
      },
      {
        user_id: 22462169,
        username: 'bluefly',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 80,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
      },
      {
        user_id: 11715310,
        username: 'Modjo85',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22885337,
        username: 'gnautTheSaturnian',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 33111274,
        username: 'TharunvenkateshN',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11636842,
        username: 'mkuurstra',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30304947,
        username: 'bobsingh.dev',
        contributor_level: 2,
        opened_merge_requests: 13,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14562778,
        username: 'nicolas.hubert1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22338125,
        username: 'apjb',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14318798,
        username: 'sepehrheydari72',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 7321838,
        username: 'banhartt',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30722311,
        username: 'vijeta004',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 33147778,
        username: 'myofsf',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 30451296,
        username: 'hisham-abdelsabour',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 6460147,
        username: 'adrien.gooris',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 386903,
        username: 'jindraj',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 20730986,
        username: 'hichemdahi57',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1388736,
        username: 'deveshchatuphale7',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 2,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26951788,
        username: 'Mithradevi_Kumar',
        contributor_level: 3,
        opened_merge_requests: 5,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 4,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11474342,
        username: 'AlexDLSy',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 1,
        added_labels: 1,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 9,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 32964731,
        username: 'strawcow',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29585132,
        username: 'zhanghaiwei55',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 27146439,
        username: 'Rishcode1',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 33187761,
        username: 'robertmercea',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 8,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19989746,
        username: 'mhdnihas',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 1,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 2,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 32893290,
        username: 'abdo.mostafa.dev',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3742884,
        username: 'mewp',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 3,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 219562,
        username: 'EricPing',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 33216923,
        username: 'Imbuzi',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 1,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 6,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 242708,
        username: 'yuhaocharlene',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 32968147,
        username: 'ShalikS-74',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 21,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 21,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23077376,
        username: 'umarajamani',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 0,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 32953127,
        username: 'RIYAKUMARI001',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 1,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 5,
        engage_points: 0,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        opened_issues: 0,
        added_labels: 0,
        closed_issues: 0,
        added_events: 0,
        added_contents: 0,
        discord_messages: 0,
        discord_replies: 0,
        forum_posts: 0,
        forum_replies: 0,
        translated_strings: 0,
        ai_contributions: 0,
        bonuses: 0,
        code_points: 0,
        plan_points: 1,
        engage_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2025-10-hackathon',
    title: 'October 2025',
    contributors: [
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 34,
        merged_merge_requests: 19,
        merged_with_issues: 19,
        merged_commits: 19,
        plan_points: 13,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 2090,
        new_score: 2483,
      },
      {
        user_id: 6878211,
        username: 'elC0mpa',
        contributor_level: 3,
        opened_merge_requests: 31,
        merged_merge_requests: 20,
        merged_with_issues: 20,
        merged_commits: 6,
        plan_points: 81,
        discuss_points: 6,
        translate_points: 0,
        bonus_points: 0,
        score: 1430,
        new_score: 2407,
      },
      {
        user_id: 14154601,
        username: 'n7800',
        contributor_level: 3,
        opened_merge_requests: 15,
        merged_merge_requests: 14,
        merged_with_issues: 3,
        merged_commits: 14,
        plan_points: 142,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 1210,
        new_score: 1632,
      },
      {
        user_id: 29580426,
        username: 'official.harshith1',
        contributor_level: 3,
        opened_merge_requests: 14,
        merged_merge_requests: 9,
        merged_with_issues: 9,
        merged_commits: 9,
        plan_points: 31,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 990,
        new_score: 1201,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 32,
        merged_merge_requests: 32,
        merged_with_issues: 31,
        merged_commits: 32,
        plan_points: 29,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 0,
        score: 850,
        new_score: 4162,
      },
      {
        user_id: 26951788,
        username: 'Mithradevi_Kumar',
        contributor_level: 2,
        opened_merge_requests: 21,
        merged_merge_requests: 10,
        merged_with_issues: 10,
        merged_commits: 11,
        plan_points: 122,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 770,
        new_score: 1443,
      },
      {
        user_id: 29076834,
        username: 'ashu07das',
        contributor_level: 3,
        opened_merge_requests: 12,
        merged_merge_requests: 6,
        merged_with_issues: 6,
        merged_commits: 3,
        plan_points: 22,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 660,
        new_score: 742,
      },
      {
        user_id: 3526849,
        username: 'eazybright',
        contributor_level: 3,
        opened_merge_requests: 6,
        merged_merge_requests: 6,
        merged_with_issues: 6,
        merged_commits: 6,
        plan_points: 4,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 100,
        score: 660,
        new_score: 888,
      },
      {
        user_id: 1927592,
        username: 'ajeymuthiah',
        contributor_level: 2,
        opened_merge_requests: 16,
        merged_merge_requests: 9,
        merged_with_issues: 9,
        merged_commits: 9,
        plan_points: 31,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 550,
        new_score: 1201,
      },
      {
        user_id: 25238487,
        username: 'SharkyBytes',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 5,
        merged_with_issues: 4,
        merged_commits: 5,
        plan_points: 36,
        discuss_points: 23,
        translate_points: 0,
        bonus_points: 0,
        score: 520,
        new_score: 679,
      },
      {
        user_id: 30645616,
        username: 'killjoycircuit',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        merged_commits: 4,
        plan_points: 20,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 440,
        new_score: 540,
      },
      {
        user_id: 5219924,
        username: 'Taucher2003',
        contributor_level: 4,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 1,
        merged_commits: 5,
        plan_points: 39,
        discuss_points: 12,
        translate_points: 0,
        bonus_points: 0,
        score: 430,
        new_score: 581,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 4,
        opened_merge_requests: 6,
        merged_merge_requests: 5,
        merged_with_issues: 0,
        merged_commits: 5,
        plan_points: 141,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 400,
        new_score: 641,
      },
      {
        user_id: 508743,
        username: 'jarka',
        contributor_level: 4,
        opened_merge_requests: 7,
        merged_merge_requests: 5,
        merged_with_issues: 0,
        merged_commits: 5,
        plan_points: 106,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 400,
        new_score: 606,
      },
      {
        user_id: 30375223,
        username: 'therealrinku',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        merged_commits: 3,
        plan_points: 13,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 330,
        new_score: 403,
      },
      {
        user_id: 194645,
        username: 'digitalmoksha',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 0,
        merged_commits: 4,
        plan_points: 69,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 320,
        new_score: 469,
      },
      {
        user_id: 30725199,
        username: 'CharTara',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 2,
        merged_commits: 3,
        plan_points: 16,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 300,
        new_score: 376,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        merged_commits: 3,
        plan_points: 31,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 240,
        new_score: 331,
      },
      {
        user_id: 30028690,
        username: 'Ahmad-Faraj',
        contributor_level: 3,
        opened_merge_requests: 34,
        merged_merge_requests: 22,
        merged_with_issues: 22,
        merged_commits: 12,
        plan_points: 37,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 2701,
      },
      {
        user_id: 9776733,
        username: 'maxbrundige444',
        contributor_level: 2,
        opened_merge_requests: 12,
        merged_merge_requests: 8,
        merged_with_issues: 8,
        merged_commits: 0,
        plan_points: 8,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 888,
      },
      {
        user_id: 22881837,
        username: 'mb8504',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 3,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 263,
      },
      {
        user_id: 30735655,
        username: 'singhsubrato2003',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 262,
      },
      {
        user_id: 30709974,
        username: 'yashes7516',
        contributor_level: 2,
        opened_merge_requests: 12,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 26,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 287,
      },
      {
        user_id: 10465958,
        username: 'tsveti22',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 2,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 266,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 26,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 286,
      },
      {
        user_id: 30727778,
        username: 'mohkarem7',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 12,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 273,
      },
      {
        user_id: 29088934,
        username: 'webmekanic',
        contributor_level: 3,
        opened_merge_requests: 5,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 25,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 100,
        score: 220,
        new_score: 388,
      },
      {
        user_id: 14845892,
        username: 'theaditya',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 5,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 265,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 262,
      },
      {
        user_id: 29931521,
        username: 'agnesjee',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 60,
        bonus_points: 0,
        score: 220,
        new_score: 322,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 6,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 266,
      },
      {
        user_id: 25858123,
        username: 'ayushjhawar499',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 8,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 268,
      },
      {
        user_id: 7825963,
        username: 'thisisrick25',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        merged_commits: 2,
        plan_points: 7,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 220,
        new_score: 267,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        plan_points: 4,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 190,
        new_score: 234,
      },
      {
        user_id: 852944,
        username: 'alexandear',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 190,
        new_score: 230,
      },
      {
        user_id: 23077376,
        username: 'umarajamani',
        contributor_level: 3,
        opened_merge_requests: 9,
        merged_merge_requests: 9,
        merged_with_issues: 8,
        merged_commits: 9,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 190,
        new_score: 1142,
      },
      {
        user_id: 10559139,
        username: 'CarnegieJ',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        plan_points: 9,
        discuss_points: 6,
        translate_points: 0,
        bonus_points: 0,
        score: 190,
        new_score: 245,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        merged_commits: 2,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 190,
        new_score: 231,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        plan_points: 8,
        discuss_points: 4,
        translate_points: 0,
        bonus_points: 0,
        score: 160,
        new_score: 212,
      },
      {
        user_id: 30774023,
        username: 'ritish050805',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        merged_commits: 2,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 160,
        new_score: 200,
      },
      {
        user_id: 5958906,
        username: 'gkepas',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 7,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 137,
      },
      {
        user_id: 12054790,
        username: 'Mohammadreza-Sarvari',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        plan_points: 12,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 122,
      },
      {
        user_id: 30713588,
        username: 'Saniiiizzz',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 132,
      },
      {
        user_id: 20214221,
        username: 'makeri89',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 130,
      },
      {
        user_id: 6409054,
        username: 'yashmaheshwari',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 4,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 134,
      },
      {
        user_id: 23080818,
        username: 'Vignesh025',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 130,
      },
      {
        user_id: 22713302,
        username: 'chizune',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 131,
      },
      {
        user_id: 30722311,
        username: 'vijeta004',
        contributor_level: 1,
        opened_merge_requests: 8,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 10,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 140,
      },
      {
        user_id: 27146439,
        username: 'Rishcode1',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 5,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 135,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 131,
      },
      {
        user_id: 12299077,
        username: 'mnazir',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 0,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 112,
      },
      {
        user_id: 1388736,
        username: 'deveshchatuphale7',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 130,
      },
      {
        user_id: 29079264,
        username: 'therealharshit',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 2,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 133,
      },
      {
        user_id: 3589694,
        username: 'jeanphi-baconnais',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 19,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 149,
      },
      {
        user_id: 28232529,
        username: 'rodrigofarii',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        merged_commits: 1,
        plan_points: 4,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 110,
        new_score: 134,
      },
      {
        user_id: 30396891,
        username: 'dvernon5',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 102,
      },
      {
        user_id: 3880218,
        username: 'mwilkins',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 100,
      },
      {
        user_id: 4624911,
        username: 'bprescott_',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 128,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 228,
      },
      {
        user_id: 9387297,
        username: 'varghesejose2020',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 101,
      },
      {
        user_id: 8841583,
        username: 'mness',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 102,
      },
      {
        user_id: 152826,
        username: 'ben.boeckel',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 5,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 85,
      },
      {
        user_id: 30709916,
        username: 'pensive_venus',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 3,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 103,
      },
      {
        user_id: 20755664,
        username: 'sbr-balean',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 101,
      },
      {
        user_id: 2404524,
        username: 'nejc',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 8,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 108,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 102,
      },
      {
        user_id: 28119655,
        username: 'denpeshkov',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 101,
      },
      {
        user_id: 30720572,
        username: 'vidyajaggi05',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 101,
      },
      {
        user_id: 1329186,
        username: 'danifbento',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 6,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 107,
      },
      {
        user_id: 555423,
        username: 'cfleee',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 4,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 104,
      },
      {
        user_id: 12245858,
        username: 'Ruislip',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        merged_commits: 1,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 80,
        new_score: 101,
      },
      {
        user_id: 5991344,
        username: 'ptalbert',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 28251692,
        username: 'wubenso',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 9,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 536474,
        username: 'parkourkarthik',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 3,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 26125986,
        username: 'jmprivate25',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 6265352,
        username: 'edith007',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 15,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 7016,
        username: 'jygastaud',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 3,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 30782535,
        username: 'revolucion010616',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 30736440,
        username: 'niftalievruslan615',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 20723965,
        username: 'kiran-4444',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 2505937,
        username: 'antonynjoroge',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 1,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 25229781,
        username: 'n.h.long.9697',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 26184019,
        username: 'bugproduction',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 7148052,
        username: 'UiP9AV6Y',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 1478745,
        username: 'kedo48',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 3656020,
        username: 'anthosz',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 4813780,
        username: 'issugo',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 1,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 9705923,
        username: 'MrMYHuang',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 30218828,
        username: 'vivvek99',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 19,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 23477414,
        username: 'ariestar',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 0,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
      {
        user_id: 24808157,
        username: 'noelpurde',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        merged_commits: 0,
        plan_points: 2,
        discuss_points: 0,
        translate_points: 0,
        bonus_points: 0,
        score: 0,
        new_score: 0,
      },
    ],
  },
  {
    id: '2025-07-hackathon',
    title: 'July 2025',
    contributors: [
      {
        user_id: 27545521,
        username: 'sahiljawale541',
        contributor_level: 3,
        opened_merge_requests: 20,
        merged_merge_requests: 18,
        merged_with_issues: 18,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 90,
      },
      {
        user_id: 29079264,
        username: 'therealharshit',
        contributor_level: 2,
        opened_merge_requests: 15,
        merged_merge_requests: 15,
        merged_with_issues: 15,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 30,
        bonus_points: 0,
        score: 75,
      },
      {
        user_id: 10402615,
        username: 'vj35.cool',
        contributor_level: 3,
        opened_merge_requests: 17,
        merged_merge_requests: 15,
        merged_with_issues: 15,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 66,
        bonus_points: 0,
        score: 75,
      },
      {
        user_id: 29076834,
        username: 'ashu07das',
        contributor_level: 2,
        opened_merge_requests: 17,
        merged_merge_requests: 13,
        merged_with_issues: 13,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 77,
        bonus_points: 0,
        score: 65,
      },
      {
        user_id: 3526849,
        username: 'eazybright',
        contributor_level: 2,
        opened_merge_requests: 14,
        merged_merge_requests: 8,
        merged_with_issues: 8,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 22,
        bonus_points: 0,
        score: 40,
      },
      {
        user_id: 27778046,
        username: 'nishant19072003',
        contributor_level: 2,
        opened_merge_requests: 14,
        merged_merge_requests: 7,
        merged_with_issues: 7,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 22,
        bonus_points: 0,
        score: 35,
      },
      {
        user_id: 23077376,
        username: 'umarajamani',
        contributor_level: 2,
        opened_merge_requests: 7,
        merged_merge_requests: 7,
        merged_with_issues: 6,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 17,
        bonus_points: 0,
        score: 31,
      },
      {
        user_id: 23477414,
        username: 'ariestar',
        contributor_level: 2,
        opened_merge_requests: 11,
        merged_merge_requests: 7,
        merged_with_issues: 6,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 17,
        bonus_points: 0,
        score: 31,
      },
      {
        user_id: 27146439,
        username: 'Rishcode1',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 6,
        merged_with_issues: 6,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 30,
      },
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 15,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 25,
        bonus_points: 0,
        score: 25,
      },
      {
        user_id: 22885337,
        username: 'gnautTheSaturnian',
        contributor_level: 2,
        opened_merge_requests: 8,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 6,
        merged_merge_requests: 4,
        merged_with_issues: 3,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 16,
      },
      {
        user_id: 28232529,
        username: 'rodrigofarii',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 20730986,
        username: 'hichemdahi57',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 11,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 33,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 29154978,
        username: 'shubhiten',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 22397678,
        username: 'SamakshAgarwal1112',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 13,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 71,
        bonus_points: 0,
        score: 7,
      },
      {
        user_id: 6361776,
        username: 'AaronDewes',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 29111714,
        username: 'dhallharsh2006',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4150253,
        username: 'cmavromichalis',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 29214867,
        username: 'freddyponce908',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23560311,
        username: 'onasser',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 20,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 14424465,
        username: 'LeanneMarie',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 25229781,
        username: 'n.h.long.9697',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1388736,
        username: 'deveshchatuphale7',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 538931,
        username: 'munishkumar631',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 29116292,
        username: 'arifusmani154',
        contributor_level: 1,
        opened_merge_requests: 5,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 33,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 26570790,
        username: 'he-patrick',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 13051670,
        username: 'michael_valet',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22712076,
        username: 'salmoneatenbybear',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 555423,
        username: 'cfleee',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 25858123,
        username: 'ayushjhawar499',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 10449020,
        username: 'tianlu1677',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 181229,
        username: 'leipert',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 20,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 23183905,
        username: 'protsivd',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 29052648,
        username: 'nshechtmann',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 12053347,
        username: 'luzhiyuan.deer',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 26723114,
        username: 'Jayne.Doe3',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 29032205,
        username: 'prageeth-thilakarathna',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 22746422,
        username: 'clotman',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 28251692,
        username: 'wubenso',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 5219924,
        username: 'Taucher2003',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 9387297,
        username: 'varghesejose2020',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 9791050,
        username: 'tim.knight1',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 16,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 2379552,
        username: 'chaserx',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 22653133,
        username: 'mookwoo',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3178316,
        username: 'abrekhov',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 27906560,
        username: 'kmcgreg-ibm',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11517614,
        username: 'sebastien.heurtematte1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14857804,
        username: 'nraj0408',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2973726,
        username: 'BalrajGupta',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29085895,
        username: 'sneaxhuh',
        contributor_level: 1,
        opened_merge_requests: 5,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 24646435,
        username: 'guptapratibha26',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 28121795,
        username: 'athirmal1',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 14384063,
        username: 'oceane_scania',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22105316,
        username: 'vmarklynn',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22474531,
        username: 'Firdous2307',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 28,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21381525,
        username: 'poojaghanghas479',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 18,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3413443,
        username: 'thiago.addevico',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 16872574,
        username: 'martin.nielsen94',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 8168103,
        username: 'ricardbejarano',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 15227156,
        username: 'katia2',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 17,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29184212,
        username: 'android.app.DownloadManager',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29202681,
        username: 'uiop860',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 5295823,
        username: 'klokkenman1',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 26,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23170969,
        username: 'j9999961',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2566574,
        username: 'Bubbis',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 7569992,
        username: 'abh80',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26444642,
        username: 'AbdulWahab03',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 29105299,
        username: 'ph2639279',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 28190000,
        username: 'achoudhary31',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25736558,
        username: 'chaitanyason9',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2025-04-hackathon',
    title: 'April 2025',
    contributors: [
      {
        user_id: 5628777,
        username: 'karras',
        contributor_level: 4,
        opened_merge_requests: 26,
        merged_merge_requests: 26,
        merged_with_issues: 25,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 153,
        bonus_points: 0,
        score: 126,
      },
      {
        user_id: 26184939,
        username: 'lincmba',
        contributor_level: 2,
        opened_merge_requests: 17,
        merged_merge_requests: 13,
        merged_with_issues: 13,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 22,
        bonus_points: 0,
        score: 65,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 4,
        opened_merge_requests: 26,
        merged_merge_requests: 25,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 31,
        bonus_points: 0,
        score: 37,
      },
      {
        user_id: 555423,
        username: 'cfleee',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 5,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 27,
        bonus_points: 0,
        score: 21,
      },
      {
        user_id: 20957087,
        username: 'aadarshraghuvanshi5',
        contributor_level: 2,
        opened_merge_requests: 20,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 21,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 26335567,
        username: 'bhanutejach9',
        contributor_level: 2,
        opened_merge_requests: 6,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 16,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 14,
        merged_merge_requests: 10,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 18,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 2178476,
        username: 'thomasgl-orange',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 5358464,
        username: 'choznerol',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 9485872,
        username: 'zehkira',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 19304051,
        username: 'mbo5be',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 24,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 25858123,
        username: 'ayushjhawar499',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 46,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 5219924,
        username: 'Taucher2003',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 20,
        bonus_points: 0,
        score: 7,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 644847,
        username: 'mankalas',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 26688301,
        username: 'bas.bremer',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2566574,
        username: 'Bubbis',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 8841583,
        username: 'mness',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 14384063,
        username: 'oceane_scania',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 44,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2090677,
        username: 'schurzi',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 670344,
        username: 'fgreinacher',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 8809399,
        username: 'qa-andreas-grub',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2063807,
        username: 'dagaranupam',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 16,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 283442,
        username: 'edsfocci',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2618816,
        username: 'narze',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22662256,
        username: 'sourabhsethi5',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 331122,
        username: 'BageDevimo',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2912363,
        username: 'TheBestHuman',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 14485925,
        username: 'ahmad-kashkoush',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4150253,
        username: 'cmavromichalis',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 26991840,
        username: 'jakubbortlik',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 25903718,
        username: 'j0sal',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22474531,
        username: 'Firdous2307',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 22,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 27073127,
        username: 'ekutyebu',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23560311,
        username: 'onasser',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 14,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 5102305,
        username: 'napuu',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 27021878,
        username: 'aryandutt',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 21,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2618716,
        username: 'darval',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 16,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 10465958,
        username: 'tsveti22',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 18562392,
        username: 'amaras-epiminder',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 27083224,
        username: 'nickyfoo',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22105316,
        username: 'vmarklynn',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 18525836,
        username: '30Piraten',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 25,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 21460394,
        username: 'aleksandr.ryabikov',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 19776827,
        username: 'nikitasakau',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23478402,
        username: 'katwal',
        contributor_level: 1,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 3,
      },
      {
        user_id: 20364955,
        username: 'benmurel',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 3,
      },
      {
        user_id: 181229,
        username: 'leipert',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 18,
        bonus_points: 0,
        score: 3,
      },
      {
        user_id: 22746419,
        username: 'ttbt0706',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 119207,
        username: 'JonasGroeger',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 18831109,
        username: 'alexandre.laroche.exfo',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 15112297,
        username: 'helmyl',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 136672,
        username: 'robgarden',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 25736558,
        username: 'chaitanyason9',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 22784006,
        username: 'KryptoXVX',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 3035621,
        username: 'philtrum',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 7882302,
        username: 'guillaume.chauvel',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 14965649,
        username: 'SantosVilanculos',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 27250003,
        username: 'dc487',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 22763253,
        username: 'bdjone19',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 13,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 9387297,
        username: 'varghesejose2020',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 12496623,
        username: 'tambochimp',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 27257602,
        username: 'frederick-LANL',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 10699005,
        username: 'wanguiwawerub',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19229490,
        username: 'kazimsarikaya',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19591720,
        username: 'Koagonzalo11',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1779412,
        username: 'tonton1728',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26226072,
        username: 'Samyak137',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3234059,
        username: 'anthonyknapper',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 16951991,
        username: 'daivikkarbhari01',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22004901,
        username: 'bwhite117',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26962355,
        username: 'acmichelman',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23477414,
        username: 'ariestar',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 165190,
        username: '1ace',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25963346,
        username: 'bartsad',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26951203,
        username: 'erwan_hivin',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2345018,
        username: 'xFuture603',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 12762581,
        username: 'BaseALTTesting',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22151117,
        username: 'carlosjco7',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 27146439,
        username: 'Rishcode1',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23436350,
        username: 'IP1102',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26473359,
        username: 'jeremydotsg',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1965376,
        username: 'duncanmmacleod',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 485765,
        username: 'Kagee',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25929991,
        username: 'knandha854',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 82354,
        username: 'tachyons',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 4040366,
        username: 'florian.heberl',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22885337,
        username: 'gnautTheSaturnian',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26685337,
        username: 'erenil87',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 26444642,
        username: 'AbdulWahab03',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 13616042,
        username: 'petport',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 27140706,
        username: 'raisa-1-sect',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22147721,
        username: 'vagrdev',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2134013,
        username: 'avalor1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 208977,
        username: 'santigl',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 92994,
        username: 'fabsrc',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11715310,
        username: 'Modjo85',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2025-01-hackathon',
    title: 'January 2025',
    contributors: [
      {
        user_id: 907418,
        username: 'abitrolly',
        contributor_level: 4,
        opened_merge_requests: 16,
        merged_merge_requests: 16,
        merged_with_issues: 14,
        opened_issues: 12,
        merged_commits: 0,
        added_notes: 131,
        bonus_points: 100,
        score: 72,
      },
      {
        user_id: 2786852,
        username: 'mschoenlaub',
        contributor_level: 2,
        opened_merge_requests: 11,
        merged_merge_requests: 9,
        merged_with_issues: 9,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 21,
        bonus_points: 0,
        score: 45,
      },
      {
        user_id: 10923734,
        username: 'crenz',
        contributor_level: 2,
        opened_merge_requests: 10,
        merged_merge_requests: 8,
        merged_with_issues: 7,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 31,
        bonus_points: 0,
        score: 36,
      },
      {
        user_id: 12968147,
        username: 'ajuckel',
        contributor_level: 3,
        opened_merge_requests: 16,
        merged_merge_requests: 9,
        merged_with_issues: 4,
        opened_issues: 4,
        merged_commits: 0,
        added_notes: 113,
        bonus_points: 0,
        score: 25,
      },
      {
        user_id: 15308696,
        username: 'alexander.marston',
        contributor_level: 3,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 5,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 27,
        bonus_points: 0,
        score: 25,
      },
      {
        user_id: 7371210,
        username: 'betty-godier',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 21,
      },
      {
        user_id: 12198778,
        username: 'antonkalmykov',
        contributor_level: 4,
        opened_merge_requests: 5,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 24,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 18657743,
        username: 'heidi.berry',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 3,
        opened_issues: 3,
        merged_commits: 0,
        added_notes: 15,
        bonus_points: 100,
        score: 16,
      },
      {
        user_id: 2090646,
        username: 'rndmh3ro',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 3,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 100,
        score: 16,
      },
      {
        user_id: 1936875,
        username: 'azinke',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 2090677,
        username: 'schurzi',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 24646435,
        username: 'guptapratibha26',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 32,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 4,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 54,
        bonus_points: 0,
        score: 13,
      },
      {
        user_id: 2566574,
        username: 'Bubbis',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 18,
        bonus_points: 0,
        score: 11,
      },
      {
        user_id: 2178476,
        username: 'thomasgl-orange',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 3,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 2629956,
        username: 'benjamhooper',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 2477108,
        username: 'nomad_blaze',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 10925656,
        username: 'vedant-jain03',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 20533124,
        username: 'sahilsarawagi',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 22978314,
        username: 'kanishk0',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 3309935,
        username: 'Rumple_17',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 25217369,
        username: 'abutkeev',
        contributor_level: 4,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 8,
      },
      {
        user_id: 181229,
        username: 'leipert',
        contributor_level: 4,
        opened_merge_requests: 9,
        merged_merge_requests: 8,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 104,
        bonus_points: 0,
        score: 8,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 3,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 7,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 15,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 5358464,
        username: 'choznerol',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 12227629,
        username: 'nicola.beirer',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1743629,
        username: 'ferricoxide',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 25858123,
        username: 'ayushjhawar499',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22743867,
        username: 'omeinderink1',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 5,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 24876009,
        username: 'peterhdangg',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 13225967,
        username: 'moorehfl',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 25859122,
        username: 'bhellis4',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 8443008,
        username: 'yashikajotwani12',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22290224,
        username: 'dc-tec',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 19,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 3172082,
        username: 'joeig',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 382902,
        username: 'candrews',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4369062,
        username: 'loozhengyuan',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1388736,
        username: 'deveshchatuphale7',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23045607,
        username: 'maldee264',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 3499242,
        username: 'yogeshlonkar',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 1646689,
        username: 'oregand',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 3,
        merged_commits: 0,
        added_notes: 33,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 22745451,
        username: 'vvpatil123',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 677520,
        username: 'jfvanderwalt',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 12277120,
        username: 'williamedwards',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 4489949,
        username: 'eurie',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 41,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 5332,
        username: 'bbodenmiller',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 11316976,
        username: 'bacebu4',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 25897880,
        username: 'RiceKrisBs',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 21577053,
        username: 'mengzhuo1203',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 22746419,
        username: 'ttbt0706',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 19488412,
        username: 'codesandeepcode',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 23312727,
        username: 'bbechtel',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 10512639,
        username: 'calee1',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 23477414,
        username: 'ariestar',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 2376752,
        username: 'ipsavitsky234',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 2624912,
        username: 'PurePlugins',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 14245614,
        username: 'jpinto9391615',
        contributor_level: 2,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 19460689,
        username: 'cade.schlaelfi',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 4070891,
        username: 'rabbixt',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1933526,
        username: 'leetickett',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 9387297,
        username: 'varghesejose2020',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23183905,
        username: 'protsivd',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22763253,
        username: 'bdjone19',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25830269,
        username: 'jingram3',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 8229932,
        username: 'jspriggs-adaptavist',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25035239,
        username: 'albertoroldanq',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25947769,
        username: 'bhoopendramasram2005',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3981182,
        username: 'robsliwi',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 420407,
        username: 'kuprel',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 24869704,
        username: '8138790117',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 25754930,
        username: 'Hungle2911',
        contributor_level: 1,
        opened_merge_requests: 3,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 3395525,
        username: 'fiveturns',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
  {
    id: '2024-10-hackathon',
    title: 'October 2024',
    contributors: [
      {
        user_id: 23152529,
        username: 'ikelax',
        contributor_level: 3,
        opened_merge_requests: 32,
        merged_merge_requests: 19,
        merged_with_issues: 19,
        opened_issues: 3,
        merged_commits: 0,
        added_notes: 48,
        bonus_points: 0,
        score: 95,
      },
      {
        user_id: 7959104,
        username: 'heysujal',
        contributor_level: 3,
        opened_merge_requests: 22,
        merged_merge_requests: 13,
        merged_with_issues: 13,
        opened_issues: 13,
        merged_commits: 0,
        added_notes: 71,
        bonus_points: 0,
        score: 65,
      },
      {
        user_id: 23078767,
        username: 'divyamtayal',
        contributor_level: 3,
        opened_merge_requests: 18,
        merged_merge_requests: 13,
        merged_with_issues: 12,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 84,
        bonus_points: 0,
        score: 61,
      },
      {
        user_id: 2090677,
        username: 'schurzi',
        contributor_level: 3,
        opened_merge_requests: 7,
        merged_merge_requests: 6,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 17,
        bonus_points: 0,
        score: 22,
      },
      {
        user_id: 13388501,
        username: 'ruben.aleman',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 5,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 19,
        bonus_points: 0,
        score: 21,
      },
      {
        user_id: 2859829,
        username: 'mpeu',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 9,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 1283330,
        username: 'max-wittig',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 1494491,
        username: 'nwittstruck',
        contributor_level: 4,
        opened_merge_requests: 5,
        merged_merge_requests: 4,
        merged_with_issues: 4,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 15,
        bonus_points: 0,
        score: 20,
      },
      {
        user_id: 10925656,
        username: 'vedant-jain03',
        contributor_level: 3,
        opened_merge_requests: 6,
        merged_merge_requests: 3,
        merged_with_issues: 3,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 19,
        bonus_points: 0,
        score: 15,
      },
      {
        user_id: 22969287,
        username: 'desertwolf453',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 45,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 8095268,
        username: 'PatrickRice',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 42,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 9547685,
        username: 'sayeedahmad',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 131751,
        username: 'joe-snyder',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 1410664,
        username: 'pierosavi',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 2,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 10,
      },
      {
        user_id: 2410096,
        username: 'JonstonChan',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 2404524,
        username: 'nejc',
        contributor_level: 3,
        opened_merge_requests: 4,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 1212822,
        username: 'khan-mansoor',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 6,
      },
      {
        user_id: 14384063,
        username: 'oceane_scania',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 28,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 12111357,
        username: 'emoceon',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 5358464,
        username: 'choznerol',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 20074650,
        username: 'Perseus985',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4375199,
        username: 'gerardo-navarro',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 53,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23027127,
        username: 'sunlee128',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 16918428,
        username: 'mason.walton',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 21130389,
        username: 'Deepak18-06',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 12198778,
        username: 'antonkalmykov',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 23,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22550482,
        username: 'jeroenmonteban_mgb',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 21923030,
        username: 'andre.ehlert',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 3510961,
        username: 'hairmare',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 22852134,
        username: 'dylan.jacob.bh',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 15397146,
        username: 'holtvogt',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 4369062,
        username: 'loozhengyuan',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 4,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 6409054,
        username: 'yashmaheshwari',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 11,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 7200222,
        username: 'davidpv98',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 3466954,
        username: 'shangsuru',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 23475545,
        username: 'david_navarro',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 14053391,
        username: 'b310-jannik',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 19666194,
        username: 'maxthier',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 1,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 5,
      },
      {
        user_id: 1808486,
        username: 'bertuxdeveloper',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 4,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 4,
      },
      {
        user_id: 19630747,
        username: 'bruhnb',
        contributor_level: 1,
        opened_merge_requests: 2,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 6342346,
        username: 'josephjose',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 10927805,
        username: 'jimender2',
        contributor_level: 3,
        opened_merge_requests: 3,
        merged_merge_requests: 2,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 2,
      },
      {
        user_id: 11804339,
        username: 'keivinonline',
        contributor_level: 2,
        opened_merge_requests: 5,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 7423230,
        username: 'syedzubeen',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 3178839,
        username: 'tete17',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 10082086,
        username: 'telliffoshea',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 23489349,
        username: 'RakinduM',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 181229,
        username: 'leipert',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 31,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 44780,
        username: 'aasanchez',
        contributor_level: 2,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 6517387,
        username: 'thexeos',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 12245858,
        username: 'Ruislip',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 133404,
        username: 'bufferoverflow',
        contributor_level: 4,
        opened_merge_requests: 3,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 10,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 12586465,
        username: 'davidebenini',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 7321838,
        username: 'banhartt',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 9387297,
        username: 'varghesejose2020',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 5219924,
        username: 'Taucher2003',
        contributor_level: 4,
        opened_merge_requests: 2,
        merged_merge_requests: 1,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 31,
        bonus_points: 0,
        score: 1,
      },
      {
        user_id: 10176563,
        username: 'Bermo5',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 73587,
        username: 'likema',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 12968147,
        username: 'ajuckel',
        contributor_level: 3,
        opened_merge_requests: 2,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1646689,
        username: 'oregand',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 18,
        merged_commits: 0,
        added_notes: 50,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 8561680,
        username: 'NIKU-SINGH',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 4489949,
        username: 'eurie',
        contributor_level: 4,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 12,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23288686,
        username: 'goellen3010',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 20257448,
        username: 'omarodeh',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 938516,
        username: 'francisferrell',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 6,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 114023,
        username: 'fh1ch',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23483160,
        username: 'klwarde',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1183916,
        username: 'wcgcoder',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22474531,
        username: 'Firdous2307',
        contributor_level: 2,
        opened_merge_requests: 4,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 22,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 20386508,
        username: 'yushao.sqpc',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19227556,
        username: 'jetttirant',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 9467528,
        username: 'neiroc',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 4,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 23367381,
        username: 'roudha.almarzooqi',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2436476,
        username: 'bigface0202',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 22182752,
        username: 'andersparslov',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 1,
        merged_commits: 0,
        added_notes: 7,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 11142300,
        username: 'knkamxs1989',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 21102467,
        username: 'simon.gregor.ebner',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1700088,
        username: 'pueblomo',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 2561044,
        username: 'dlouzan',
        contributor_level: 3,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 8,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1985736,
        username: 'pierresebastien',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 2,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1689242,
        username: 'belfhi',
        contributor_level: 0,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 818659,
        username: 'asfourco',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 0,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 1832709,
        username: 'ercan.ucan',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 2,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 19482949,
        username: 'riyansh_b',
        contributor_level: 2,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 3,
        bonus_points: 0,
        score: 0,
      },
      {
        user_id: 769963,
        username: 'B.Wollgramm',
        contributor_level: 1,
        opened_merge_requests: 1,
        merged_merge_requests: 0,
        merged_with_issues: 0,
        opened_issues: 0,
        merged_commits: 0,
        added_notes: 1,
        bonus_points: 0,
        score: 0,
      },
    ],
  },
];
